<template>
  <div class="absolute left-1/2 -translate-x-1/2">
    <slot />
  </div>
</template>
